<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Profit Loss</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="vertical-flex">
                  <p class="mt-3">
                    The Profit & Loss Forecast shows your expected income and expenses for upcoming months, giving you a clear picture of your projected profitability.
                    Sinchii uses your historical data and current inputs to estimate future revenue and costs, helping you plan ahead and make informed financial decisions. You can update forecasts anytime to reflect changes in your business.
                  </p>
                  <img src="@/assets/images/profit-loss-data.png" alt="Profit & Loss Forecasts" class="img-fluid form-center" />
                  <p class="mt-5">
                    For more information about profit and loss and how to use Sinchii, click <a href="https://sinchii.com.au/resources/" target="_blank">here</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="close">Let's Begin</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../Icon.vue";

export default {
  components: {
    icon
  },
  methods: {
    close() {
      this.$emit("onClose");
    }
  }
};

</script>
